__turbopack_context__.v({
  "active": "layout-module__TTENja__active",
  "backdrop": "layout-module__TTENja__backdrop",
  "container": "layout-module__TTENja__container",
  "contentWrapper": "layout-module__TTENja__contentWrapper",
  "loadingContainer": "layout-module__TTENja__loadingContainer",
  "logoMobile": "layout-module__TTENja__logoMobile",
  "logoTagline": "layout-module__TTENja__logoTagline",
  "logoText": "layout-module__TTENja__logoText",
  "logoutBtn": "layout-module__TTENja__logoutBtn",
  "main": "layout-module__TTENja__main",
  "menuToggle": "layout-module__TTENja__menuToggle",
  "mobileHeader": "layout-module__TTENja__mobileHeader",
  "nav": "layout-module__TTENja__nav",
  "navIcon": "layout-module__TTENja__navIcon",
  "navItem": "layout-module__TTENja__navItem",
  "open": "layout-module__TTENja__open",
  "sidebar": "layout-module__TTENja__sidebar",
  "sidebarHeader": "layout-module__TTENja__sidebarHeader",
  "spin": "layout-module__TTENja__spin",
  "spinner": "layout-module__TTENja__spinner",
  "userAvatar": "layout-module__TTENja__userAvatar",
  "userDetails": "layout-module__TTENja__userDetails",
  "userEmail": "layout-module__TTENja__userEmail",
  "userInfo": "layout-module__TTENja__userInfo",
  "userRole": "layout-module__TTENja__userRole",
  "userSection": "layout-module__TTENja__userSection",
});
